/** Visible game build. Keep the private package version independent. */
export const GAME_VERSION = "v2026.09.03-08";
